import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionNames, chooseFiles, previewImageResults, PreviewImages } from '../actions';

const readFile = async (file: File) => new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = e => {
        res(e.target.result);
    };
    reader.readAsDataURL(file);
});

function* previewImages(action: PreviewImages) {
    const {files : fileList} = action;
    const files = [...Array(fileList.length).keys()].map(i =>  fileList.item(i));
    const imageUrls: string[] = [];

    for (const file of files) {
        const imageUrl = yield call(readFile, file);
        imageUrls.push(imageUrl);
    }

    yield put(previewImageResults(imageUrls));

    yield put(chooseFiles(files));
}

function* handlePreviews() {
    yield takeEvery(ActionNames.ReviewActions.preview, previewImages);
}

export default handlePreviews;
